export const listBoxSizes = {
   listBoxOption: ' rounded-10px',

   sectionHeader: 'px-4 py-3 text-sm-semibold',

   section: 'py-1'
}
